import { WidgetsClientDetailMain } from '@/widgets/client-detail';

export const PagesClientDetailMain = () => <WidgetsClientDetailMain />;
